import React from 'react'
import style from './Services.module.scss'
import CardFeature from './CardFeature/CardFeature'

function Services({ translation }) {

    let features = [

        { logo: "bi bi-speedometer2", title: translation("services.title-fast"), text: translation("services.description-fast"), animacion: 'fade-left', duration: "1000" },
        { logo: "bi bi-phone", title: translation("services.title-responsive"), text: translation("services.description-responsive"), animacion: 'fade-left', duration: "2000" },
        { logo: "bi bi-rocket-takeoff", title: translation("services.title-dynamic"), text: translation("services.description-dynamic"), animacion: 'fade-left', duration: "3000" },
    ]
    return (
        <div className={style.container} id="services">
            <h3>{translation("navbar.service")}</h3>
            <div className={style.container__wrapper}>
                <div className={style.container__wrapper__content}
                    data-aos={"fade-right"}
                    data-aos-duration={"1000"}
                >
                    <b>{translation("services.title-freelance")}</b>
                    <p
                    >
                        {translation("services.freelance-description-one")}
                        <a href={`mailto:rodri_ribes@hotmail.com?Subject=${encodeURI("Propuesta desde el Portfolio")}`} target="_blank" rel="noreferrer">
                            Email
                        </a>
                        {translation("services.freelance-description-two")} <br /> <br />
                        {translation("services.freelance-description-three")}
                    </p>
                    {/* <p
                    >
                        Visita mi pagina
                        <a href={`mailto:rodri_ribes@hotmail.com?Subject=${encodeURI("Propuesta desde el Portfolio")}`} target="_blank" rel="noreferrer">
                            Ribes-Solutions
                        </a>
                        y contrata el servicio que mas encaje a tu necesidad. <br /> <br />
                        Si tenes una muy buena idea pero no tenes el capital para contratar el servicio, nos podes contactar y
                        podemos llegar a un acuerdo por el servicio prestado.
                    </p> */}
                    <b>{translation("services.title-company")}</b>
                    <p>
                        {translation("services.company-description-one")}
                        <a href={`mailto:rodri_ribes@hotmail.com?Subject=${encodeURI("¿ Coordinamos una Entrevista ?")}`} target="_blank" rel="noreferrer">
                            {translation("services.company-description-two")}
                        </a>
                        {translation("services.company-description-three")}
                    </p>
                </div>
                <div className={style.container__wrapper__features}>
                    {
                        features.map(f => <CardFeature key={f.title} title={f.title} logo={f.logo} text={f.text} animacion={window.innerWidth < 966 ? undefined : f.animacion} duration={f.duration} />)
                    }
                </div>
            </div>
        </div>
    )
}

export default Services